import { render, staticRenderFns } from "./adjustments.vue?vue&type=template&id=3e68a0f8&scoped=true&"
import script from "./adjustments.vue?vue&type=script&lang=js&"
export * from "./adjustments.vue?vue&type=script&lang=js&"
import style0 from "./adjustments.vue?vue&type=style&index=0&id=3e68a0f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68a0f8",
  null
  
)

export default component.exports